import { useEffect } from 'react';
import type { Channel } from '@conversia/shared-types';
import { Select } from '@/components/ui/Select';
import { canalPreseleccionado } from '@/lib/avisos-canal';

/**
 * "Canal (de qué vendedora es)" del cliente dado de alta a mano.
 *
 * Cada canal de WhatsApp es el teléfono de una vendedora, y de ese número le
 * llegan al cliente sus recordatorios y avisos. Con un solo canal viene elegido;
 * con varios hay que elegir (el servidor también lo exige).
 */
export function CanalDelClienteSelect({
  canales,
  value,
  onChange,
}: {
  /** Canales de WhatsApp (ver `canalesWhatsApp`). */
  canales: Channel[];
  value: string;
  onChange: (channelId: string) => void;
}) {
  // Preselección cuando hay uno solo: nadie tiene que tocar nada.
  useEffect(() => {
    if (value) return;
    const unico = canalPreseleccionado(canales);
    if (unico) onChange(unico);
  }, [canales, value, onChange]);

  return (
    <Select
      label="Canal (de qué vendedora es)"
      required
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="" disabled>
        {canales.length === 0 ? 'No hay canales de WhatsApp' : 'Elige el canal…'}
      </option>
      {canales.map((c) => (
        <option key={c.id} value={c.id}>
          {c.name}
        </option>
      ))}
    </Select>
  );
}
